const productRoute = window.location.pathname.match(/products-v2/) ? 'products-v2' : 'products'

export const SHIPPING_SCROLL_ANCHORS = {
  address: 'address',
  method: 'method',
}

export const PAYMENT_SCROLL_ANCHORS = {
  address: 'address',
  method: 'method',
}

export default {
  checkout: 'checkout-v2',
  checkoutRegistration: 'registration',
  checkoutShipping: 'shipping',
  checkoutPayment: 'payment',
  checkoutConfirmation: 'confirmation',
  pageNotFound: 'page-not-found',
  product: productRoute,
  npsFeedback: 'nps-feedback',
  shoeFinder: 'shoe-finder',
  demo: 'demo',
  demoForm: 'demo-form',
  demoSizing: 'demo-sizing',
  demoDyApi: 'demo-dy-api',
}
